import { AztecProduct } from 'types/models/Menu';

interface MenuModalImageProps {
  aztecProduct: AztecProduct;
}

export const MenuModalImage: React.FC<MenuModalImageProps> = ({
  aztecProduct,
}) => {
  const displayRecord =
    aztecProduct?.displayRecords[aztecProduct.displayRecordId];

  const productName = displayRecord?.name || aztecProduct?.displayName;

  return displayRecord.image !== '' ? (
    <div>
      <img
        className="menu-modal-image"
        src={displayRecord.image}
        alt={displayRecord?.alt_text || productName}
      />
    </div>
  ) : null;
};
